<section class="cloud-infrastructure-hero">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="hero-content text-center">
                    <span class="hero-badge">Legal Information</span>
                    <h1 class="hero-title">Privacy Policy</h1>
                    <p class="hero-description">Your privacy is important to us. This privacy policy explains how we collect, use, and protect your personal information.</p>
                    
                    <div class="hero-actions justify-content-center">
                        <a class="btn-primary-gradient me-3" routerLink="/contact">
                            <i class="bx bx-phone"></i>
                            Contact Us
                        </a>
                        <a class="btn-outline-light" routerLink="/terms-conditions">
                            <i class="bx bx-file"></i>
                            Terms & Conditions
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="hero-background-elements">
        <div class="bg-element element-1"></div>
        <div class="bg-element element-2"></div>
        <div class="bg-element element-3"></div>
    </div>
</section>

<section class="company-overview-section ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="overview-content">
                    <div class="section-title text-center mb-5">
                        <span class="section-badge">Our Privacy Policy</span>
                        <h2>Privacy <span class="text-highlight">Policy</span></h2>
                        <p class="overview-description">This Privacy Policy describes how Insightful IT Services collects, uses, and protects your personal information.</p>
                    </div>
                    
                    <div class="single-terms">
                        <h3><i class="bx bx-info-circle"></i> Information We Collect</h3>
                        <p>We collect information you provide directly to us when you use our services, create an account, or communicate with us. This may include your name, email address, phone number, company information, payment details, and any other information you choose to provide.</p>
                        <p>We also automatically collect certain information about your device and usage of our services, including your IP address, browser type, operating system, referring URLs, and information about how you interact with our services.</p>

                        <h3><i class="bx bx-cog"></i> How We Use Information</h3>
                        <p>We use the information we collect to provide, maintain, and improve our services, to communicate with you, to process transactions, and to comply with legal obligations. Specifically, we may use your information to:</p>
                        <ul>
                            <li>Provide and maintain our cloud infrastructure services</li>
                            <li>Process payments and manage billing</li>
                            <li>Communicate with you about our services</li>
                            <li>Provide customer support and respond to inquiries</li>
                            <li>Monitor and analyze usage patterns and trends</li>
                            <li>Detect, prevent, and address technical issues</li>
                            <li>Comply with legal obligations and protect our rights</li>
                        </ul>

                        <h3><i class="bx bx-shield-alt"></i> Information Protection</h3>
                        <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. These measures include encryption, access controls, and regular security assessments.</p>
                        <p>All data is stored in secure data centers with physical security measures and 24/7 monitoring. Access to personal information is limited to authorized personnel who need it to perform their job functions.</p>

                        <h3><i class="bx bx-share-alt"></i> Information Sharing</h3>
                        <p>We do not sell, trade, or rent your personal information to third parties. We may share your information with trusted third parties who assist us in operating our services, conducting our business, or serving our users, as long as those parties agree to keep this information confidential.</p>
                        <p>We may also disclose your information if required by law, to protect our rights, or in connection with a merger, acquisition, or sale of all or a portion of our assets.</p>

                        <h3><i class="bx bx-cookie"></i> Cookies and Tracking Technologies</h3>
                        <p>We use cookies and similar tracking technologies to track activity on our services and store certain information. These technologies are used to enhance user experience, analyze trends, and gather demographic information.</p>
                        <p>You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our services.</p>

                        <h3><i class="bx bx-globe"></i> Data Retention</h3>
                        <p>We retain your personal information for as long as necessary to provide our services and fulfill the purposes outlined in this policy, unless a longer retention period is required or permitted by law.</p>
                        <p>When we no longer need your personal information, we will delete or anonymize it, unless we are required to retain it for legal or regulatory purposes.</p>

                        <h3><i class="bx bx-world"></i> Your Rights</h3>
                        <p>You have the right to access, update, or delete your personal information at any time. You may also have the right to object to or restrict certain processing of your information, and to data portability.</p>
                        <p>To exercise these rights, please contact us using the information provided below. We will respond to your request in accordance with applicable data protection laws.</p>

                        <h3><i class="bx bx-edit"></i> Policy Changes</h3>
                        <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.</p>
                        <p>We encourage you to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>

                        <h3><i class="bx bx-envelope"></i> Contact Us</h3>
                        <p>If you have any questions about this Privacy Policy, please contact us at:</p>
                        <p>Email: info@insightfulitservices.com</p>
                        <p>Phone: +91 9167663638</p>
                        <p>Locations: Mumbai & Noida, India</p>
                        <p>Last Updated: September 11, 2025</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>